import { wxOpenApp } from '../../../frontend-lib/component/wxToAPP'
import { goApp, addQueryToUrl } from '../../../frontend-lib/tools/utils.js'
import allToApp from '@yxl/open-app'
import { Base64 } from 'js-base64'
import { axios as $http, setHeader, track } from 'cm'
import './style.scss'
import './css/DINCondensedBold.css'
import {
  getRunTime,
  debounce,
  unitConversion,
  GetQueryString
} from '../../../public-resource/libs/utils/index'
import Mp from '../../../public-resource/libs/utils/mp'
import Bridge from '../../../public-resource/libs/Bridge/Bridge'
import qs from 'qs'
import loginModal from '../../../public-resource/components/LoginModal/dialog'
import Reward from '../../../public-resource/components/reward/index'
import APIS from './api'
import cepingComment from './components/cepingComment'
import { resetIframeSize } from './components/video'
import { handleCopy } from '../../../public-resource/libs/appCommand/command'
import { scrollLoop } from './components/scroll'
import { getWechatAuth } from './wechatAuth'
import { LinkHandler } from './js/LinkHandler.js'
import Optimizer2657 from './js/Optimizer2657.js'
import BookListComponent from './js/BookListComponent.js'
import RuleComponent from './js/RuleComponent.js'
import {
  copyStr,
  getCommandRequest
} from '../../../frontend-lib/component/wxToAPP/appCommand.js'
import { broswerLoadedToDownloadApp } from '@yxl/libs'
import { addPageLinkQuery } from 'src/public-resource/libs/utils/addPageLinkQuery.js'
import router from 'src/public-resource/libs/utils/router.js'

// 判断环境
let HOST = getRunTime('//m.xinli001.com')
let UA = window.navigator.userAgent
const IS_IOS = /(iPhone|iPad|iPod|iOS)/i.test(UA)
const IS_APP = window.$platform.isYixinliApp

const isWechat = window.$platform.isWechat
const mp = new Mp()

let cur_click_event = null
// 导入富文本CSS
$('head').append(
  '<link rel="stylesheet" href="https://static.xinli001.com/fe-app/style/theme-yixinli.css">'
)

// 领取地址
const getCouponURL = window.baseInfo.coupon_url

// 优惠券参数
const activityID = window.baseInfo.activity.id

// 口令
let command = ''
if (!IS_APP) {
  getCommandRequest({
    type: 'act',
    object_id: '',
    title: window.baseInfo.wx_share_config.title,
    desc: window.baseInfo.wx_share_config.desc,
    url: window.location.href
  }).then(res => {
    command = res
  })
}

if (GetQueryString('from') === 'message') {
  broswerLoadedToDownloadApp()
}

// 如果是1、是微信 2、未登录 3、url含有code参数，则自动去获取授权登录
if (isWechat && +window.login_info.is_login !== 1 && GetQueryString('code')) {
  getWechatAuth()
}

const handleUrlParams = (url, pick) => {
  const urlSearchParams = qs.parse(url.search.replace('?', ''))
  /*
   * ban_wshare 禁止分享的参数
   * callApp 唤起壹心理App的参数
   */
  return pick ? urlSearchParams['' + pick] : urlSearchParams
}

if (handleUrlParams(location, 'callApp')) {
  console.log('前往APP')
  location.href = 'yixinli://open_main'
}

// // 由于后端数据结构修改比较麻烦，用js修改文章列表结构

let articleList = $('.article_wrap')
if (articleList.length) {
  let ArticlesCollects = reduceArticleCollect()
  ArticlesCollects.forEach(articles => {
    let flag = articles[0] && articles[0].previousSibling
    let articleContent = $('<div class="article_box"></div>')
    articleContent.append(articles)
    articleContent.insertBefore(flag)
  })
}

function reduceArticleCollect() {
  let arr = []
  Array.from(articleList).forEach((el, index) => {
    let lastCollect = arr.pop() || []
    if (!lastCollect.length) lastCollect.push(el)
    if (
      el.nextElementSibling &&
      el.nextElementSibling.classList.contains('article_wrap')
    ) {
      lastCollect.push(el.nextElementSibling)
      arr.push(lastCollect)
    } else {
      arr.push(lastCollect)
      if (articleList.length !== index + 1) arr.push([])
    }
  })
  return arr
}

let modal
if (
  document.querySelectorAll(
    'li[data-name="zixun.yuyue"],li[data-name="zixun.qingsu"]'
  ).length
) {
  modal = new loginModal('content', handleLogin)
}

// 记录正在领取的优惠券id，登陆时需要传给后台查询对应咨询师标记来源
let takingCouponId = ''

/**
 *
 * @param phone 手机号
 * @param validCode 验证码
 * @returns {Promise}
 */
function handleLogin(phone, validCode) {
  const url = `${HOST}/consult_activity/popularize/create-or-bind`
  // const url = `http://m-box3.xinli001.com/ajax/create-or-bind`
  return new Promise(resolve => {
    // #1138 【10月需求】激励计划订单标记 start
    let channel = GetQueryString('channel_flag')
    let _url = url + `?phone=${phone}&validCode=${validCode}`
    if (channel === 'jljh' && takingCouponId) {
      _url += `&registerMark=${channel}_${takingCouponId}`
      takingCouponId = ''
    }
    // #1138 【10月需求】激励计划订单标记 end

    $http.get(_url).then(res => {
      console.log(res)
      const { code, message, data } = res.data
      if (code === 0) {
        window.toast(message)
        login_info.phone = phone
        login_info.is_login = '1'

        $http.interceptors.request.use(res => {
          const _token = data.token
          if (res.url.indexOf('?') === -1) {
            res.url = res.url + '?token=' + _token
          } else {
            res.url = res.url + '&token=' + _token
          }
          return res
        })

        $http.get(HOST + '/get-certification-cookie.json')

        resolve()
      } else {
        window.toast(message)
      }
    })
  })
}

// 领取优惠券
const couponList = document.getElementsByClassName('couponList')
console.log(couponList.length)
let coupons
// console.log(couponList)
if (couponList.length > 1) {
  coupons = []
  for (let i = 0; i < couponList.length; i++) {
    coupons[i] = couponList[i].getElementsByTagName('li')
    console.log(coupons[i].length)
    couponListInit(coupons[i], couponList[i])
  }
} else if (couponList.length) {
  console.log(couponList[0])
  coupons = couponList[0].getElementsByTagName('li')
  couponListInit(coupons, couponList[0])
}

function couponListInit(opt, list) {
  let len = opt.length
  if (len > 3 && len < 6) {
    let x = 6 - len
    for (let i = 0; i < x; i++) {
      let $li = document.createElement('li')
      $li.classList = 'couponItem-none'
      list.appendChild($li)
    }
  }
}

function getCoupon(e) {
  let target = e.target
  // coupon_id;
  if (target.tagName.toLowerCase() === 'ul') return
  while (target.tagName.toLowerCase() !== 'li') {
    target = target.parentNode
  }

  const couponID = target.getAttribute('value')
  const objectName = target.getAttribute('data-name')
  const couponType = target.getAttribute('data-type') || ''

  window.yxl.stat.send({
    name: '公共-交互行为',
    properties: {
      页面: '专题模板页',
      对象: '领取优惠券',
      优惠券ID: couponID || '',
      业务: objectName || '',
      页面标题: window.baseInfo.activity.name
    }
  })

  if (couponID && objectName) {
    console.log(
      ['zixun.yuyue', 'zixun.qingsu'].indexOf(objectName) > -1,
      Number(login_info.is_login) !== 1
    )

    // http://112.124.122.87:8084/index.php?m=story&f=view&storyID=2609
    if (
      isWechat &&
      +window.baseInfo.wx_phone_login == 1 &&
      !+login_info.phone
    ) {
      toLogin()
      return
    }

    if (
      ['zixun.yuyue', 'zixun.qingsu'].indexOf(objectName) > -1 &&
      // !+login_info.phone
      Number(login_info.is_login) !== 1 // #1189 若当前仍可领取，则直接领取成功。（不需要再绑定手机）
    ) {
      // takingCouponId = couponID
      // modal.openModal()
      toLogin()
      return
    }

    if (
      Number(login_info.is_login) !== 1 &&
      isWechat &&
      objectName === 'college.lesson'
    ) {
      getWechatAuth()
    } else {
      receiveCoupon(getCouponURL, couponID, activityID, objectName, couponType)
    }
  } else {
    window.toast('敬请期待')
  }
}

function receiveCoupon(
  getCouponURL,
  couponID,
  activityID,
  objectName,
  couponType
) {
  $http
    .get(
      getCouponURL +
        '?coupon_id=' +
        couponID +
        '&activity_id=' +
        activityID +
        '&object_name=' +
        objectName +
        '&coupon_type=' +
        couponType
    )
    // $http.get(`http://m-box3.xinli001.com/activity/get-coupon` + '?coupon_id=' + couponID +"&activity_id=" + activityID + "&object_name=" + objectName)
    .then(res => {
      if (res.data.code === 0) {
        window.toast(res.data.message)
      } else {
        window.toast(res.data.message)
      }
    })
    .catch(err => {
      console.log(err)
      window.toast('优惠券领取失败')
    })
}

if (couponList.length) {
  if (couponList.length > 1) {
    for (let i = 0; i < couponList.length; i++) {
      couponList[i].addEventListener('click', debounce(getCoupon, 300))
    }
  } else {
    couponList[0].addEventListener('click', debounce(getCoupon, 300))
  }
}

// 6.20 添加点击埋点

// 标签模块埋点
let flagEle = document.querySelector('.label-list')
let testEle = document.querySelector('.testList')

let eleArr = ['label-list', 'qs_list', 'recommend_list']

eleArr.forEach(item => {
  let els = document.getElementsByClassName(item),
    el
  if (!els.length) return
  if (els.length === 1) {
    el = els[0]
    bindEvent(el)
  } else {
    Array.from(els).forEach(item => {
      bindEvent(item)
    })
  }

  function bindEvent(el) {
    el.addEventListener('click', e => {
      let target = e.target,
        title,
        businessType
      if (['label-list'].indexOf(item) > -1) {
        while (target.tagName.toLowerCase() !== 'a') {
          target = target.parentNode
        }
        title = target.getAttribute('title')
        if (item === 'label-list') businessType = '标签'

        // app弹窗
        handleToApp(e, target)
      } else if (['qs_list', 'recommend_list'].indexOf(item) > -1) {
        if (target.tagName.toLowerCase() === 'a') {
          title = target.getAttribute('title')
          if (item === 'qs_list') businessType = '倾诉'
          if (item === 'recommend_list') businessType = '咨询'
          // app弹窗
          if (item !== 'qs_list' && item !== 'recommend_list')
            handleToApp(e, target)
        }
      }

      window.yxl.stat.send({
        name: '公共-交互行为',
        properties: {
          行为: '点击',
          页面: '专题模板页',
          对象: title || '',
          业务: businessType || '',
          页面标题: window.baseInfo.activity.name
        }
      })
    })
  }
})

/**
 *
 * * 阻止a标签默认跳转，并判断显示跳转app弹窗
 * @param {*} e
 * @param {*} target  目标a标签
 */
async function handleToApp(e, target) {
  if (!sessionStorage.getItem('app_show_flag')) {
    sessionStorage.setItem('app_show_flag', 1) // 判断是否弹窗及拦截跳转
    e.preventDefault()
    const appDialog = $('.app-dialog-wrap')
    cur_click_event = target
    appDialog.show()
  }
}
window.handleToApp = handleToApp // 勿删。LinkHandler.js中用到。

function _goApp() {
  // const link = window.location.href
  // const href = `yixinli://open_h5?url=${Base64.encode(link)}`
  // goApp(href)

  copyStr(command)
  goApp('yixinli://')
}

function setAppDialog() {
  if ($('.app-dialog-wrap').length === 0) {
    let appAialog = `<div class="app-dialog-wrap">
      <div class="app-dialog-mask"></div>
      <div class="app-dialog-content">
      <p class="app-dialog-title">是否打开壹心理App查看该页面？</p>
      <div class="btn-group">
        <span class="btn app-cancel">取消</span>
        <span class="btn app-confirm">确定</span>
      </div>
      </div>
    </div>`
    $('body').append(appAialog)

    const { activity = {}, app_package_url } = window.baseInfo
    let AppConfirm = document.querySelector('.app-confirm')
    allToApp({
      el: AppConfirm,
      title: activity.name || '',
      desc: activity.desc || '',
      url: window.location.href,
      errAndroidUrl: app_package_url,
      errIosUrl: app_package_url
    })

    $('.app-cancel').click(() => {
      $('.app-dialog-wrap').hide()

      // 平台-专题模板页-App打开引导弹窗-取消神策埋点
      track.trackEvent('specialtopic_appdownloadpopup_cancel', {})

      if (cur_click_event) window.location.href = cur_click_event.href
    })
    $('.app-confirm').click(event => {
      // 平台-专题模板页-App打开引导弹窗-确定神策埋点
      track.trackEvent('specialtopic_appdownloadpopup_sure', {})
    })
  }
}

if (!IS_APP) setAppDialog()

setTimeout(() => {
  console.info(window.$platform)
  const defaultOpenApp = +window.baseInfo.default_open_app
  const isApp =
    window.$platform.isYixinliApp ||
    window.$platform.isZiXunApp ||
    window.$platform.isZiXunShiApp
  if (defaultOpenApp === 1 && !isApp && !window.$platform.isWechat) {
    // if (window.$platform.isiPhone || window.$platform.isiPad) {
    //   _goApp()
    // } else if (window.$platform.isAndroid) {
    $('.app-dialog-wrap').show()
    // }
  }
}, 50)

// 微信分享
if (window.$platform.isWechat) {
  let currentUrl = document.location.href
  let getWxConfig = `${HOST}/wx/get-wx-package.json`
  $http
    // .get(getWxConfig + '?url=' + encodeURIComponent(currentUrl))
    .get(getWxConfig + '?url=' + encodeURIComponent(currentUrl) + '&name=yida')
    .then(res => {
      if (res.data.code == 0) {
        var wxConfig = res.data.data

        function loadScript(url, callback) {
          var script = document.createElement('script')
          script.type = 'text/javascript'
          if (typeof callback !== 'undefined') {
            if (script.readyState) {
              script.onreadystatechange = function() {
                if (
                  script.readyState == 'loaded' ||
                  script.readyState == 'complete'
                ) {
                  script.onreadystatechange = null
                  callback()
                }
              }
            } else {
              script.onload = function() {
                callback()
              }
            }
          }
          script.src = url
          document.body.appendChild(script)
        }

        setTimeout(() => {
          loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js', () => {
            var _config = {
              debug: wxConfig.debug,
              appId: wxConfig.appId,
              timestamp: wxConfig.timestamp,
              nonceStr: wxConfig.nonceStr,
              signature: wxConfig.signature,
              jsApiList: [
                'hideMenuItems',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone',
                'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
                'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
              ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              openTagList: ['wx-open-launch-app']
            }

            // 微信基本配置信息
            wx.config(_config)

            wx.ready(function() {
              if (handleUrlParams(location, 'ban_wshare')) {
                wx.hideMenuItems({
                  menuList: [
                    'menuItem:share:appMessage',
                    'menuItem:share:timeline',
                    'menuItem:share:qq',
                    'menuItem:share:QZone',
                    'menuItem:share:weiboApp',
                    'menuItem:openWithQQBrowser',
                    'menuItem:openWithSafari',
                    'menuItem:copyUrl',
                    'menuItem:favorite' // 禁止收藏，因为可以收藏之后再分享出去
                  ] // 要隐藏的菜单项，所有menu项见附录3
                })
              } else {
                var shareConfig = {
                  title: window.baseInfo.wx_share_config.title,
                  desc: window.baseInfo.wx_share_config.desc,
                  link: window.baseInfo.wx_share_config.url,
                  imgUrl: window.baseInfo.wx_share_config.cover, // 图片地址
                  success: function(res) {},
                  cancel: function(res) {},
                  fail: function(res) {}
                }
                // 分享到朋友圈
                wx.onMenuShareTimeline(shareConfig)
                // 分享给朋友
                wx.onMenuShareAppMessage(shareConfig)
                // 分享到QQ
                wx.onMenuShareQQ(shareConfig)
                // 分享到腾讯微博
                wx.onMenuShareWeibo(shareConfig)
                // 分享到QQ空间
                wx.onMenuShareQZone(shareConfig)
                wx.updateAppMessageShareData(shareConfig)
                wx.updateTimelineShareData(shareConfig)
              }
            })
            wxOpenApp.init()
          })
        }, 500)
      }
    })
}

// 微信小程序分享
if (Mp.isWebviewMp) {
  mp.postMessage({
    type: 'share',
    data: {
      ...window.baseInfo.wx_share_config,
      link: window.baseInfo.wx_share_config.url,
      imgUrl: window.baseInfo.wx_share_config.cover
    }
  })
}

// APP分享
if (IS_APP) {
  var myBrige = new Bridge({
    methods: [
      {
        method: 'topFuncBtn',
        callback: function(ops) {
          if (ops.name == 'shareReportBtn') {
            var share_config = {
              title: window.baseInfo.wx_share_config.title,
              desc: window.baseInfo.wx_share_config.desc,
              link: window.baseInfo.wx_share_config.url,
              imgUrl: window.baseInfo.wx_share_config.cover, // 图片地址
              // 动态分享的字段
              isShowDynamic: 1,
              object_id: window.baseInfo.activity.id,
              object_type: 8,
              object_title: window.baseInfo.wx_share_config.title,
              object_cover: window.baseInfo.wx_share_config.cover
            }
            myBrige.call('shareReport', share_config)
          }
        }
      }
    ]
  })
  myBrige.call('topFuncBtnConfig', {
    btnList: [
      {
        name: 'shareReportBtn',
        visible: 1
      }
    ]
  })
}

/*
 * author: htd
 * time: 2019-03-13
 * description: 大咖活动
 */

let userToken = null
let userId = null
let isShowAppBtn = !IS_APP && +window.baseInfo.default_open_app === 1
let toTopDiv = `<div class="side-bar">
${
  isShowAppBtn
    ? `<div style="position: relative">
            <div
                    class="wxOpenInAPP"
                    style="position: absolute;width: 100%;height: 100%;left: 0;top: 0;z-index: 2;display: ${
                      isWechat ? 'block' : 'none'
                    }"
                    data-object-id="${window.baseInfo.activity.id}"
                    data-title ="${window.baseInfo.wx_share_config.title}"
                    data-desc=" ${window.baseInfo.wx_share_config.desc}"
                    data-url="${window.baseInfo.wx_share_config.url}"
                    data-type="act"
            > </div>
             <div class="toApp">App<br/>查看</div>
            </div>`
    : ''
}
<div class="toTop"></div>
</div>`
let openUserLoginUrl = 'yixinli://open_user_login'
if ($('.toTop').length === 0) {
  $('body').append(toTopDiv)
}
$(window).scroll(function() {
  var scrollTop = $(this).scrollTop()
  var windowHeight = $(this).height()
  if (scrollTop >= windowHeight + 100) {
    $('.toTop').show()
  } else {
    $('.toTop').hide()
  }
})

// 在描述内容中提取是否隐藏app悬浮按钮关键字：happ
const IS_HIDE_APP = window.baseInfo.activity.desc.includes('happ')
if (isShowAppBtn && IS_HIDE_APP) {
  let title = document.title
  document.title = title.replace('-壹心理', '')
  $('.toApp').hide()
  sessionStorage.setItem('app_show_flag', 1)
}

/* 专题模板底部按钮支持微信打开app -start- */
if (!isWechat) {
  $('.wxOpenInAPP').hide()
}
if (!IS_APP) {
  $('.footer-btn-open-wx>a').attr('href', 'javascript:;')
  if (!isWechat) {
    $('.footer-btn-open-wx').each(function() {
      if ($(this).children('.wxOpenInAPP').length > 0) {
        const object_id =
          $(this)
            .children('.wxOpenInAPP')
            .data('objectid') || ''
        const title =
          $(this)
            .children('.wxOpenInAPP')
            .data('title') || ''
        const desc =
          $(this)
            .children('.wxOpenInAPP')
            .data('desc') || ''
        const url =
          $(this)
            .children('.wxOpenInAPP')
            .data('url') || ''
        const type =
          $(this)
            .children('.wxOpenInAPP')
            .data('type') || ''

        const { activity = {}, app_package_url } = window.baseInfo
        allToApp({
          el: this,
          title: activity.name || '',
          desc: activity.desc || '',
          url: window.location.href,
          errAndroidUrl: app_package_url,
          errIosUrl: app_package_url
        })
      }
    })
  }
}

const CHANNEL = GetQueryString('channel_flag') || ''
// 页面访问神策埋点
track.trackPageView('specialtopic_view', {
  specia_id: window.baseInfo.activity.id,
  channel_flag: CHANNEL
})

/* 专题模板底部按钮支持微信打开app -end- */

// app查看
if (!IS_APP && isShowAppBtn) {
  $('.toApp').click(e => {
    // 平台-专题模板页-点击App查看按钮神策埋点
    track.trackEvent('specialtopic_appdownloadbutton', {})

    $('.app-dialog-wrap').show()

    // 平台-专题模板页-App打开引导弹窗-出现神策埋点
    track.trackEvent('specialtopic_appdownloadpopup_view', {})
  })
}

// 回到顶部
$('.toTop').click(function() {
  $('html,body')
    .stop()
    .animate(
      {
        scrollTop: '0'
      },
      200,
      'swing'
    )
})

function toLogin() {
  window.toast('未登录，稍后为您跳转到登录页面', 3000)
  window.loginTimer = setTimeout(() => {
    let _href = IS_APP
      ? openUserLoginUrl
      : `${APIS.login}?next=${encodeURIComponent(
          window.location.href.replace('xinli001.xin', 'xinli001.com')
        )}`
    window.location.href = _href
  }, 2000)
}

window.getTokenFn = function(obj) {
  let newObj = JSON.parse(obj)
  if (newObj.token) {
    userToken = newObj.token
  } else {
    // window.location.href = 'yixinli://open_user_login';
  }
  let rewardOBJ = new Reward({
    el: '.reward',
    token: userToken,
    userId: userId,
    jumpWXpay: true,
    callbackFn: function() {
      // 打赏成功 变颜色
      let object_id = window.localStorage.getItem('rewardObjId')
      $(`[data-objectid=${this.object_id}]`).addClass('rewarded')
    }
  })
  let userRewarOBJ = new Reward({
    el: '.icon-icon-shang',
    token: userToken,
    userId: userId,
    jumpWXpay: true,
    payType: 'user.reward'
  })
}

// 抖动功能
let startVibrate = function(level) {
  navigator.vibrate(level)
}

// 向TA提问
function askFn(invite_user) {
  let jumpUrl
  if (invite_user) {
    jumpUrl = HOST + '/qa/post-question-view?invite_user=' + invite_user
  } else {
    jumpUrl = HOST + '/qa/post-question-view'
  }
  window.location.href = jumpUrl
}

$('.content').on(
  'click',
  '.ask_btn,.follow,.youyong,.reward,.sameFeel,.share',
  function() {
    if ($(this).hasClass('ask_btn')) {
      let invite_user = $(this).attr('user-id') || ''
      window.yxl.stat.send({
        name: '公共-交互行为',
        properties: {
          页面: '专题模板页',
          对象: '[按钮]-向ta提问',
          业务: '问答',
          页面标题: window.baseInfo.activity.name
        }
      })
      askFn(invite_user)
    } else if ($(this).hasClass('follow')) {
      window.yxl.stat.send({
        name: '公共-交互行为',
        properties: {
          页面: '专题模板页',
          对象: '[按钮]-关注ta',
          业务: '问答',
          页面标题: window.baseInfo.activity.name
        }
      })
      followFn($(this))
    } else if ($(this).hasClass('youyong')) {
      window.yxl.stat.send({
        name: '公共-交互行为',
        properties: {
          页面: '专题模板页',
          对象: '[按钮]-有用',
          业务: '问答',
          页面标题: window.baseInfo.activity.name
        }
      })
      like($(this))
    } else if ($(this).hasClass('reward')) {
      window.yxl.stat.send({
        name: '公共-交互行为',
        properties: {
          页面: '专题模板页',
          对象: '[按钮]-打赏',
          业务: '问答',
          页面标题: window.baseInfo.activity.name
        }
      })
    } else if ($(this).hasClass('share')) {
      window.yxl.stat.send({
        name: '公共-交互行为',
        properties: {
          页面: '专题模板页',
          对象: '[按钮]-分享',
          业务: '问答',
          页面标题: window.baseInfo.activity.name
        }
      })
    } else {
      window.yxl.stat.send({
        name: '公共-交互行为',
        properties: {
          页面: '专题模板页',
          对象: '[按钮]-有同感',
          业务: '问答',
          页面标题: window.baseInfo.activity.name
        }
      })
      sameFeelFn($(this))
    }
  }
)

// 初始化打赏组件
function initReward() {
  // 回答打赏初始化
  let rewardOBJ = new Reward({
    el: '.reward',
    token: userToken,
    userId: userId,
    jumpWXpay: true,
    callbackFn: function() {
      // 打赏成功 变颜色
      let object_id = window.localStorage.getItem('rewardObjId')
      $(`[data-objectid=${this.object_id}]`).addClass('rewarded')
    }
  })
  let userRewarOBJ = new Reward({
    el: '.icon-icon-shang',
    token: userToken,
    userId: userId,
    jumpWXpay: true,
    payType: 'user.reward'
  })
}
// 测试代码
// userToken = '4d2a1g4ag2d42g42a12d42a4dh'
// userId = '456487545741'
// initReward()

// 获取用户基本信息
$http
  .get(APIS.isLogin, {
    params: {}
  })
  .then(res => res.data)
  .then(res => {
    if (+res.code === 0) {
      if (res.data.user && res.data.user.token) {
        userToken = res.data.user.token || ''
        userId = res.data.user.id || ''
        initReward()
      } else if (IS_APP) {
        myBrige.call('getToken', {
          callbackName: 'getTokenFn'
        })
      } else {
        initReward()
      }
    }
  })
// 有用功能
let likeTimer
let liking = false

function like(e) {
  if (!userToken) {
    toLogin()
    return
  }
  if (liking) {
    return
  }
  let answerId = e.attr('data-answer-id')
  let user_id = e.attr('data-user-id')

  if (userId === user_id) {
    window.toast('不能点自己！')
    return
  }
  liking = true
  let currentNum = +$(e).attr('data-number')
  $http
    .get(APIS.like, {
      params: {
        answer_id: answerId
      }
    })
    .then(
      res => {
        let _data = res.data
        if (+_data.code === 0) {
          _data = _data.data
          /* 点赞情况 */
          let newNum
          if (+_data.is_zan === 1) {
            // 抖动效果
            if (IS_APP) {
              myBrige.call('shake', {
                milliseconds: 200
              })
            } else {
              if ('vibrate' in navigator) {
                startVibrate(200)
              }
            }
            newNum = currentNum + 1
            $(e)
              .find('i')
              .removeClass('icon-youyong')
              .addClass('icon-xuanzhong')
            $(e).addClass('active')
          } else {
            /* 非点赞 */
            newNum = currentNum - 1
            $(e)
              .find('i')
              .addClass('icon-youyong')
              .removeClass('icon-xuanzhong')
            $(e).removeClass('active')
          }

          if (newNum < 0) {
            newNum = 0
          }
          $(e).attr('data-number', newNum)
          $(e)
            .find('label')
            .html(unitConversion(newNum))
        } else {
          window.toast(_data.message)
        }
        clearTimeout(likeTimer)
        likeTimer = setTimeout(() => {
          liking = false
        }, 500)
      },
      err => {
        console.error(err)
        likeTimer = setTimeout(() => {
          liking = false
        }, 500)
      }
    )
}
// 关注
let following = false

function followFn(e) {
  let user_id = $(e).attr('user-id')
  if (!userToken) {
    toLogin()
    return
  }

  if (following) {
    return
  }
  if (userId == $(this).attr('user-id')) {
    window.toast('不能关注自己~')
    return
  }
  following = true
  $http
    .get(APIS.follow, {
      params: {
        user_id: user_id
      }
    })
    .then(
      res => {
        let _data = res.data
        if (+_data.code === 0) {
          if (+_data.data.is_follow === 1) {
            $(e).html('已关注')
          } else {
            $(e).html('关注ta')
          }
        } else {
          window.toast(_data.message)
        }
        following = false
      },
      err => {
        window.toast(err)
        following = false
      }
    )
}

// 同感
let sameFeelStatus = false

function sameFeelFn(e) {
  if (!userToken) {
    toLogin()
    return
  }
  if (sameFeelStatus) {
    return
  }
  sameFeelStatus = true
  let question_id = $(e).attr('data-question_id')

  $http
    .get(APIS.feeling, {
      params: {
        question_id: question_id
      }
    })
    .then(res => res.data)
    .then(res => {
      sameFeelStatus = false
      var newNumber = ''
      if (+res.code === 0) {
        if (+res.data.is_same_feeling === 1) {
          if (
            $(e)
              .find('p')
              .eq(0)
              .html()
              .indexOf('w') < 0 &&
            $(e)
              .find('p')
              .eq(0)
              .html()
              .indexOf('k') < 0
          ) {
            newNumber =
              parseInt(
                $(e)
                  .find('p')
                  .eq(0)
                  .html()
              ) + 1
            newNumber = newNumber < 0 ? 0 : newNumber
            $(e)
              .find('p')
              .eq(0)
              .html(unitConversion(newNumber) + '人')
          }
          $(e).addClass('active')
        } else {
          if (
            $(e)
              .find('p')
              .eq(0)
              .html()
              .indexOf('w') < 0 &&
            $(e)
              .find('p')
              .eq(0)
              .html()
              .indexOf('k') < 0
          ) {
            newNumber =
              parseInt(
                $(e)
                  .find('p')
                  .eq(0)
                  .html()
              ) - 1
            newNumber = newNumber < 0 ? 0 : newNumber
            $(e)
              .find('p')
              .eq(0)
              .html(unitConversion(newNumber) + '人')
          }
          $(e).removeClass('active')
        }
      } else {
        window.toast(res.message)
      }
      // window.toast(res.message);
    })
    .catch(err => {
      sameFeelStatus = false
      window.toast(err)
    })
}

// TOP10 tab切换
$('.question_list_tab li').click(function() {
  let index = $(this).index()
  let questionListDom = $(this)
    .parents('.question_list')
    .eq(0)
  questionListDom.attr('ativeNum', index)
  questionListDom
    .find('.question_list_ul ul')
    .eq(index)
    .show()
  questionListDom
    .find('.question_list_ul ul')
    .eq(index)
    .siblings()
    .hide()
  $(this)
    .addClass('active')
    .siblings()
    .removeClass('active')

  if (
    questionListDom
      .find('.question_list_ul ul')
      .eq(index)
      .find('li').length < 10 &&
    index === 0
  ) {
    $(this).attr('isnone', '1')
  }

  let isNone = $(this).attr('isnone')
  if (+isNone === 1) {
    $(questionListDom)
      .find('.comment_more')
      .hide()
  } else {
    $(questionListDom)
      .find('.comment_more')
      .show()
  }
  let targetDom = $(this)
    .parents('.question_list')
    .eq(0)
    .find('.question_list_ul ul')
    .eq(index)
  if (
    $(targetDom)
      .eq(index)
      .find('li').length === 0 &&
    +isNone === 0
  ) {
    getBigShotData($(this).attr('data-url'), $(this), targetDom)
  }
})

$('.comment_more label').click(function() {
  let index = +$(this)
    .parents('.question_list')
    .eq(0)
    .attr('ativeNum')
  let url = $(this)
    .parents('.question_list')
    .eq(0)
    .find('.question_list_tab li')
    .eq(index)
    .attr('data-url')
  let targetDom = $(this)
    .parents('.question_list')
    .eq(0)
    .find('.question_list_ul ul')
    .eq(index)
  let tabDom = $(this)
    .parents('.question_list')
    .eq(0)
    .find('.question_list_tab li')
    .eq(index)
  getBigShotData(url, tabDom, targetDom)
})

function getBigShotData(url, i, e) {
  let getStatus = $(i).attr('getStatus')
  if (+getStatus === 1) {
    return
  }
  $(i).attr('getStatus', '1')
  $(e)
    .parents('.question_list')
    .eq(0)
    .find('.loading-more')
    .show()
  let page = $(i).attr('page')
  $http
    .get(url, {
      params: {
        page: page,
        size: 10
      }
    })
    .then(res => res.data)
    .then(res => {
      $(e)
        .parents('.question_list')
        .eq(0)
        .find('.loading-more')
        .hide()
      $(i).attr('getStatus', '0')
      let LiHtml = ''
      if (+res.code === 0) {
        page++
        $(i).attr('page', page)
        if (res.data.length < 10) {
          $(e)
            .parents('.question_list')
            .eq(0)
            .find('.comment_more')
            .hide()
          $(i).attr('isnone', '1')
        }
        res.data.map((item, index) => {
          LiHtml += `<li>
            <div class="question_item_title">
              <a href="${HOST}/qa/${item.id}">${item.title}
                <span>(${item.zannum}有用)</span>
              </a>
            </div>
            <div class="sameFeel ${
              +item.is_same_feeling === 1 ? 'active' : ''
            }" data-question_id="${item.id}">
              <p>${item.same_feeling_num}人</p>
              <p>有同感</p>
            </div>
          </li>`
        })
        $(e).append(LiHtml)
      } else {
        window.toast(res.message)
      }
    })
    .catch(err => {
      window.toast(err)
      $(i).attr('getStatus', '0')
      $(e)
        .parents('.question_list')
        .eq(0)
        .find('.loading-more')
        .hide()
    })
}

// 倒计时
function setTimeoutFn(timeData, e) {
  this.day = ''
  this.hour = ''
  this.minute = ''
  this.second = ''
  this.str = ''
  this.ask_timer = null
  this.oDate = new Date() //获取日期对象
  this.oldTime = this.oDate.getTime() //现在距离1970年的毫秒数
  this.newDate = new Date(timeData.replace(/-/g, '/'))
  this.newTime = this.newDate.getTime() //2019年距离1970年的毫秒数
  this.allSecond = Math.floor((this.newTime - this.oldTime) / 1000) //未来时间距离现在的秒数
  this.tow = function(n) {
    return n >= 0 && n < 10 ? '0' + n : '' + n
  }

  let that = this
  this.getDate = function() {
    if (that.allSecond <= 0) {
      that.day = 0
      that.hour = 0
      that.minute = 0
      that.second = 0
      clearInterval(that.ask_timer)
    } else {
      that.day = Math.floor(that.allSecond / 86400) //整数部分代表的是天；一天有24*60*60=86400秒
      that.hour = Math.floor((that.allSecond % 86400) / 3600) //整数部分代表小时
      that.minute = Math.floor(((that.allSecond % 86400) % 3600) / 60)
      // second %= 60
      that.second = ((that.allSecond % 86400) % 3600) % 60
    }
    that.str = `<span>${that.tow(that.day)}</span>天<span>${that.tow(
      that.hour
    )}</span>时<span>${that.tow(that.minute)}</span>分<span>${that.tow(
      that.second
    )}</span>秒`
    $(e).html(that.str)
    that.allSecond--
  }
  this.getDate()
  $(e).show()
  clearInterval(this.ask_timer)
  this.ask_timer = setInterval(this.getDate, 1000)
}

window.onload = function() {
  let timeList = $('.time_div')
  timeList.map((i, item) => {
    let dataTime = $(item).attr('data-time')
    if (dataTime.trim() !== '') {
      new setTimeoutFn(dataTime, $(item))
    }
  })
  // 视频组件有外部的iframe会重新设置大小
  resetIframeSize()
  // 自动识别和初始化
  cepingComment()
  // 弹幕无缝滚动
  scrollLoop()
  // 处理链接跳转
  new LinkHandler()
  new Optimizer2657()
  new BookListComponent()
  new RuleComponent()

  // 全局的a标签，新增自定义参数
  addPageLinkQuery({
    // _source_page_: encodeURIComponent('专题模板页')
    _source_page_: 'zhuantimobanye'
  })
}

// 大咖活动end

// 埋点统计
// 去掉类型判断
// if (+window.baseInfo.activity_type === 2) {
let activityYype =
  +window.baseInfo.activity_type === 2 ? '关键字模板' : '运营生成模板'

let channel_flag = GetQueryString('channel_flag') || ''
let page = GetQueryString('page') || ''
let site = GetQueryString('site') || ''

window.yxl.stat.send({
  name: '公共-页面访问',
  properties: {
    页面: '专题模板页',
    模板ID: window.baseInfo.activity.id,
    页面标题: window.baseInfo.activity.name,
    活动模板类型: activityYype,
    channel_flag,
    page,
    site
  }
})
// }

// 图片点击跳转埋点
$('.somepic-wrap>.somepic>a').click(function(item) {
  if ($(this).attr('href') && $(this).attr('href') !== 'javascript:;') {
    track.trackEvent('topictemplatepage_clickontheimage', {
      specia_id: window.baseInfo.activity.id,
      image_link_address: $(this).attr('href')
    })
  }
})

// 全局修改a标签跳转方式，支持openWebview
// 除文章页 m.xinli001.com/info/ www,xinli001.com/info/ 客户端会通过a标签跳转来特殊处理
$('body>.content a').on('click', function(event) {
  if ($(this).attr('href') && $(this).attr('href') !== 'javascript:;') {
    if (
      window.$platform.isYixinliApp &&
      $(this)
        .attr('href')
        .includes('.xinli001.com/info/')
    ) {
      return
    }
    // 阻止默认的链接跳转行为
    event.preventDefault()

    // 获取链接的 href 属性值
    var href = $(this).attr('href')
    router.openWebView(href)
  }
})



// WEBPACK FOOTER //
// ./src/pages/promotion/template/index.js